import { render } from "./InputPassword.vue?vue&type=template&id=1f24fb3c&ts=true"
import script from "./InputPassword.vue?vue&type=script&lang=ts"
export * from "./InputPassword.vue?vue&type=script&lang=ts"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__